import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const dewPoint_ABOVE: typeof valueTypeRenderers.dewPoint_ABOVE = {
  label: () => unitConverter.dewPointAboveCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.dewPointAboveCanopy().title(),
      render: (n) => unitConverter.dewPointAboveCanopy(n).valueAsString(),
    }),
}
